<template>
  <div class="box">
    <!--空白-->
    <div class="blank"></div>
    <!--头像信息-->
    <div class="user_boxs">
      <div class="user_info_box">
        <img class="user_imgs" :src="wechatUser.headimgurl" />
        <div class="user_right_boxs">
          <div class="user_name">{{ realName }}</div>
          <div class="user_login">{{ userName }}</div>
        </div>
      </div>
      <!-- 暂时隐藏20230906 -->
      <!-- <div class="modify_box">
        <div @click="updateMaterial" class="update">修改个人资料</div>
        <van-icon name="arrow" class="update_img" color="#000" />
      </div> -->
    </div>
    <!--当前角色-->
    <div class="current_role" @click="currentRole">
      <div class="current_role_text">当前角色</div>

      <div
        class="current_role_item"
        v-for="(item, index) in marks"
        :key="index"
      >
        {{ item }}
      </div>
      <!-- <van-icon name="arrow" class="current_img" color="#000" /> -->
    </div>
    <!--登录设置-->
    <div class="loginSet">
      <div class="set_text">登陆设置</div>
    </div>
    <!-- 暂时隐藏20230906 -->
    <!--修改绑定手机号-->
    <!-- <div class="updatePhoneNumber" @click="changeNumber">
      <div class="updatePhoneNumber_text">修改绑定手机号</div>
      <div class="updatePhoneNumber_box">
        <div class="updatePhoneNumber_number">{{ mobile }}</div>
        <van-icon name="arrow" class="updatePhoneNumber_img" color="#000" />
      </div>
    </div> -->
    <!--修改密码-->
    <div class="bindWeChat" @click="changePassWord">
      <div class="bindWeChat_text">修改密码</div>
      <van-icon name="arrow" class="bindWeChat_img" color="#000" />
    </div>
    <!-- 基本设置 -->
    <div class="loginSet">
      <div class="set_text">基本设置</div>
    </div>
    <div class="message">
      <div class="message_text">
        通知消息
      </div>
      <van-switch
        class="message_switch"
        size="20"
        active-color="#3377ff"
        inactive-color="#c2c5cc"
        v-model="checked1"
      />
    </div>
    <div class="authority">
      <div class="authority_text_one">
        系统权限
      </div>
      <div class="authority_text_two">
        授权使用的手机权限
      </div>
      <van-icon name="arrow" class="authority_img" color="#000" />
    </div>
    <div class="about">
      <div class="about_text_one">
        关于我们
      </div>
      <div class="about_text_two">
        版本v1.0.1
      </div>
      <van-icon name="arrow" class="about_img" color="#000" />
    </div>
    <!--按钮-->
    <van-button class="box_button_text" @click="logout">退出登录</van-button>
  </div>
</template>

<script>
import qs from "qs";
import {removeToken} from '@/utils/auth'
import store from '@/store';
export default {
  name: "accountManage",

  data() {
    return {
      realName: "真实姓名",
      userName: "登录账号",
      marks: [],
      mobile: "",
      wechatUser: "",
      checked: true,
      checked1: false,
      checked2: false,
    };
  },
  mounted() {
    this.wechatUser = JSON.parse(localStorage.getItem("wechatUser")) || {};
    this.init();
  },
  methods: {
    //返回
    backToLast() {
      this.$router.go(-1);
    },
    init() {
      this.userInfo_v2 = JSON.parse(localStorage.getItem("userInfo_v2")) || this.$store.state.userInfo_v2;
      const { user, identity } = this.userInfo_v2;
      this.userInfo = user;
      this.userName = user?.nickName || "昵称";
      this.realName = user?.userName || "真实姓名";
      const { identityType } = identity;
      if (identityType == "4") {
        this.marks = ["分销员"];
      } else if (identityType == "3") {
        this.marks = ["分销商"];
      } else {
        this.marks = ["普通用户"];
      }
      this.mobile = user?.mobile || '';
    },
    //修改资料
    updateMaterial() {
      this.$router.push({ path: "/person/personInfo" });
    },
    //当前角色
    currentRole() {
      //   this.$router.push({ path: "" });
    },
    //修改手机号
    changeNumber() {
      this.$router.push({ path: "/person/changeNumber" });
    },
    //修改密码
    changePassWord() {
      this.$router.push({ path: "/person/changePassword" });
    },

    //退出
    logout() {
      //   localStorage.clear();
      //   sessionStorage.clear();
      // this.$router.push({ path: "/login" });
      this.$API.user
        .unbundling()
        .then((res) => {
          localStorage.setItem("flag", "true");
          localStorage.setItem("removeShareId", "true");
          // localStorage.setItem("openId", null)
          removeToken();
          this.$router.push({ path: "/login" });
        })
        .catch((err) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  background-color: #f4f6f9;
  height: 100%;
  padding-bottom: vw(100);

  .box_top_info {
    width: vw(750);
    height: vw(88);
    background-color: #ffffff;
    display: flex;
    flex-direction: row;
    text-align: center;

    .back_img {
      width: vw(28);
      height: vw(28);
      margin-left: vw(38);
      margin-top: vw(30);
      color: #333333;
    }

    .address_manage {
      width: vw(120);
      height: vw(30);
      margin-top: vw(27);
      margin-left: vw(249);
      color: #333333;
      font-size: vw(30);
      font-family: Source Han Sans CN;
    }
  }

  .blank {
    width: vw(750);
    height: vw(2);
    background-color: #ffffff;
  }

  .user_boxs {
    height: vw(180);
    padding-left: vw(30);
    padding-right: vw(30);
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #ffffff;
    justify-content: space-between;
    .user_info_box {
      display: flex;
      flex-direction: row;
      align-items: center;
      .user_imgs {
        width: vw(100);
        height: vw(100);
        background-color: black;
        border-radius: 50%;
      }

      .user_right_boxs {
        margin-left: vw(24);

        .user_name {
          font-size: vw(36);
          font-family: Source Han Sans CN;
          font-weight: bold;
          line-height: vw(61);
          color: #333333;
          opacity: 1;
        }

        .user_login {
          font-size: vw(24);
          font-family: Source Han Sans CN;
          font-weight: 400;
          line-height: vw(43);
          color: #c2c5cc;
        }
      }
    }

    .modify_box {
      display: flex;
      flex-direction: row;
      align-items: center;
      .update {
        margin-right: vw(10);
        font-size: vw(30);
        font-family: Source Han Sans CN;
        color: #c2c5cc;
      }

      .update_img {
      }
    }
  }

  .current_role {
    margin-top: vw(1);
    padding-left: vw(30);
    padding-right: vw(30);
    height: vw(110);
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #ffffff;
    justify-content: space-between;
    .current_role_text {
      font-size: vw(30);
      font-family: Source Han Sans CN;
      color: #333333;
      opacity: 1;
    }

    .current_role_item {
      text-align: center;
      font-size: vw(22);
      padding: vw(6) vw(20);
      font-family: Source Han Sans CN;
      color: $theme-color;
      opacity: 1;
      background-color: #e9f6ff;
      border-radius: vw(4);
    }

    .current_img {
    }
  }

  .loginSet {
    height: vw(94);
    width: vw(750);
    .set_text {
      padding-top: vw(40);
      margin-left: vw(32);
      font-size: vw(30);
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #333333;
      opacity: 1;
    }
  }
  .message {
    height: vw(110);
    background-color: #ffffff;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    margin-top: vw(2);

    .message_text {
      margin-left: vw(32);
      font-size: vw(30);
      font-family: Source Han Sans CN;
      color: #333333;
      opacity: 1;
    }

    .message_switch {
      margin-right: vw(32);
    }
  }

  .authority {
    height: vw(110);
    background-color: #ffffff;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    margin-top: vw(2);

    .authority_text_one {
      margin-left: vw(32);
      font-size: vw(30);
      font-family: Source Han Sans CN;
      color: #333333;
      opacity: 1;
    }

    .authority_text_two {
      margin-left: vw(236);
      font-size: vw(30);
      font-family: Source Han Sans CN;
      color: #c2c5cc;
      opacity: 1;
    }

    .authority_img {
      margin-right: vw(35);
    }
  }
  .about {
    height: vw(110);
    background-color: #ffffff;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    margin-top: vw(2);

    .about_text_one {
      margin-left: vw(32);
      font-size: vw(30);
      font-family: Source Han Sans CN;
      color: #333333;
      opacity: 1;
    }

    .about_text_two {
      margin-left: vw(380);
      font-size: vw(30);
      font-family: Source Han Sans CN;
      color: #c2c5cc;
      opacity: 1;
    }

    .about_img {
      margin-right: vw(35);
    }
  }

  .updatePhoneNumber {
    padding-left: vw(30);
    padding-right: vw(30);
    height: vw(111);
    display: flex;
    align-items: center;
    flex-direction: row;
    background-color: #ffffff;
    justify-content: space-between;
    .updatePhoneNumber_text {
      font-family: Source Han Sans CN;
      color: #333333;
      opacity: 1;
    }
    .updatePhoneNumber_box {
      display: flex;
      flex-direction: row;
      align-items: center;
      .updatePhoneNumber_number {
        margin-right: vw(10);
        font-size: vw(30);
        font-family: Source Han Sans CN;
        color: #333333;
        opacity: 1;
      }

      .updatePhoneNumber_img {
      }
    }
  }

  .bindWeChat {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    padding-left: vw(30);
    padding-right: vw(30);
    height: vw(111);
    background-color: #ffffff;
    margin-top: vw(2);

    .bindWeChat_text {
      font-family: Source Han Sans CN;
      color: #333333;
    }

    .bindWeChat_img {
    }
  }

  .box_button_text {
    width: vw(686);
    height: vw(88);
    margin-top: vw(113);
    margin-left: vw(32);
    margin-bottom: vw(100);
    background-color: $theme-color;
    font-size: vw(30);
    font-family: Source Han Sans CN;
    color: #ffffff;
    border-radius: vw(8);
  }
}
</style>
